import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
  addCheckOut as addCheckOutApi,
  getCartList as getCartListApi
} from "../../helpers/fakebackend_helper";
 

export const addCheckOut = createAsyncThunk("ecommerce/addCheckOut", async (cart) => {
  try {
    const response = addCheckOutApi(cart);
    const data = await response;
    toast.success("Product Added Successfully", { autoClose: 3000 });
    return data;
  } catch (error) {
    toast.error("Product Added Failed", { autoClose: 3000 });
    return error;
  }
});
  



// Kanban Board
export const getCartList = createAsyncThunk("tasks/getTasks", async () => {
  try {
      const response = getCartListApi();
      return response;
  } catch (error) {
      return error;
  }
});